import React, { useEffect, useState } from "react";
import { ContactUsForm } from "../forms/contact-us/contact-us-form";
import { ContactUsExtendedForm } from "../forms/contact-us-extended/contact-us-extended-form";
import { BrandingForm } from "../forms/pricing/branding/branding-form";
import { BrandingExtendedForm } from "../forms/pricing/branding-extended/branding-extended";
import { CorporateForm } from "../forms/pricing/corporate/corporate-form";

const FORM_QUERY_PARAM = "form";

type FormType =
  | "contact-us"
  | "contact-us-extended"
  | "branding"
  | "branding-extended"
  | "corporate";

const isFormType = (value: string | null): value is FormType =>
  value === "contact-us" ||
  value === "contact-us-extended" ||
  value === "branding" ||
  value === "branding-extended" ||
  value === "corporate";

const clearFormQueryParam = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(FORM_QUERY_PARAM)) {
    return;
  }

  url.searchParams.delete(FORM_QUERY_PARAM);
  const search = url.searchParams.toString();
  const nextUrl = `${url.pathname}${search ? `?${search}` : ""}${url.hash}`;
  window.history.replaceState({}, "", nextUrl);
};

export const OpenFormByQuery = () => {
  const [formType, setFormType] = useState<FormType | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const form = params.get(FORM_QUERY_PARAM);
    if (isFormType(form)) {
      setFormType(form);
    }
  }, []);

  const closeHandle = () => {
    setFormType(null);
    clearFormQueryParam();
  };

  if (!formType) {
    return null;
  }

  switch (formType) {
    case "contact-us-extended":
      return (
        <ContactUsExtendedForm isOpen closeHandle={closeHandle} />
      );
    case "branding":
      return (
        <BrandingForm
          isOpen
          closeHandle={() => closeHandle()}
        />
      );
    case "branding-extended":
      return (
        <BrandingExtendedForm isOpen closeHandle={closeHandle} />
      );
    case "corporate":
      return <CorporateForm isOpen closeHandle={closeHandle} />;
    case "contact-us":
    default:
      return <ContactUsForm isOpen closeHandle={closeHandle} />;
  }
};
